<template>
  <div>

    <div class="ui huge menu">
      <a href="#" class="item" @click.prevent="triggerMenu">
        <i class="content icon"></i>
      </a>
      <div class="right menu"></div>
      <a href="#" class="red item" @click.prevent="addBoat"><i class="plus icon"></i> Add Boat</a>
    </div>
    <div class="ui container">
      <h3 class="ui header">
        Boats
      </h3>

      <div class="ui loader" :class="{ 'active': fetching }"></div>

      <table class="ui table">
        <thead>
        <tr>
          <th>
            Name
          </th>
          <th>
            Order
          </th>
          <th>
            Type
          </th>
          <th>
            Price
          </th>
          <th>
            Capacity
          </th>
          <th>
            Visible For Booking
          </th>
          <th>
            Starts At
          </th>
          <th class="collapsing">
            Actions
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="boat in boats">
          <td>{{ boat.name }}</td>
          <td>{{ boat.order }}</td>
          <td>
            <div class="ui label">{{ boat.type }}</div>
          </td>
          <td>
            €{{ boat.price }}/h
          </td>
          <td>
            {{ boat.capacity.max }} Pax
          </td>
          <td>
            <div :class="{ 'green': !boat.hidden, 'red': boat.hidden }" class="ui label">
              {{ boat.hidden ? 'No' : 'Yes' }}
            </div>
          </td>
          <td>
            {{ boat.startsAtHalfHour ? '**:30' : '**:00' }}
          </td>
          <td class="collapsing">
            <div class="ui tiny buttons">
              <div class="ui button" @click="editBoat(boat)"><i class="edit icon"></i> Edit Boat</div>
              <div class="ui floating dropdown blue icon button" @click.stop="">
                <i class="dropdown icon"></i>
                <div class="menu">
                  <div class="item" @click="editBoat(boat)"><i class="edit icon"></i> Edit Boat</div>
                  <div class="item" @click="triggerDeleteBoat(boat)"><i class="trash icon"></i> Delete Boat</div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>


    </div>

    <div class="ui small basic delete modal">
      <div class="header" style="text-align: center">
        Are you sure?
      </div>
      <div class="content" style="text-align: center">
        Delete boat <strong v-if="boatForDelete">{{ boatForDelete.name }}</strong>
      </div>
      <div class="actions" style="text-align: center">
        <div class="ui red basic cancel inverted button">
          <i class="remove icon"></i>
          No
        </div>
        <div class="ui green ok inverted button" @click="deleteBoat(boatForDelete)">
          <i class="checkmark icon"></i>
          Yes
        </div>
      </div>
    </div>

    <div class="ui small modal" id="boatModal">
      <i class="close icon"></i>
      <div class="header">
        <span v-if="boat._id">Edit Boat</span>
        <span v-else>Add Boat</span>
      </div>
      <div class="content">
        <form class="ui form" @submit.prevent>
          <div class="ui field">
            <label>Type</label>
            <select class="ui selection dropdown" v-model="boat.type">
              <option value="">Select...</option>
              <option value="insel">Insel</option>
              <option value="sofa">Sofa Boat</option>
              <option value="paper">Paper Boat</option>
              <option value="oktagon">Oktagon</option>
            </select>
          </div>
          <div class="ui field">

          </div>
          <div class="ui two fields">
            <div class="field">
              <label>Name</label>
              <input class="ui input" v-model="boat.name">
            </div>
            <div class="field">
              <label>Order</label>
              <input class="ui input" type="number" v-model="boat.order">
            </div>
          </div>
          <div class="ui two fields">
            <div class="field">
              <label>People: Min</label>
              <input class="ui input" type="number" v-model="boat.capacity.min">
            </div>
            <div class="field">
              <label>People: Max</label>
              <input class="ui input" type="number" v-model="boat.capacity.max">
            </div>
          </div>
          <div class="ui field">
            <label>Price p/h (€)</label>
            <input class="ui input" type="number" v-model="boat.price">
          </div>
          <div class="ui two fields">
            <div class="field">
              <label>Hidden for public booking</label>
              <div class="ui toggle checkbox">
                <input type="checkbox" v-model="boat.hidden">
                <label></label>
              </div>
            </div>
            <div class="field">
              <label>Corona - Starts at half hour (**:30)</label>
              <div class="ui toggle checkbox">
                <input type="checkbox" v-model="boat.startsAtHalfHour">
                <label></label>
              </div>
            </div>
          </div>
          <div class="ui field">
            <label>Description</label>
            <vue-editor v-model="boat.description"></vue-editor>
          </div>
        </form>
      </div>
      <div class="actions">
        <div class="ui icon cancel button">
          <i class="delete icon"></i> Close
        </div>
        <div class="ui icon positive button" @click="saveBoat">
          <i class="checkmark icon"></i> Save Boat
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services/'
  import { VueEditor } from 'vue2-editor'

  export default {
    data() {
      return {
        'boats': [],
        'settings': {},
        'boat': {
          capacity: {}
        },
        'boatForDelete': null,
        'fetching': false,
        'moment': moment
      }
    },
    mounted() {
      this.fetchBoats()

      services.boatService.on('created', () => { this.fetchBoats() })
      services.boatService.on('patched', () => { this.fetchBoats() })
      services.boatService.on('removed', () => { this.fetchBoats() })

      $('.huge.menu').visibility({
        type: 'fixed',
        offset: 0
      });
    },
    computed: {
    },
    beforeDestroy() {
      $('.ui.modals').remove()
    },
    methods: {
      fetchBoats() {
        this.fetching = true

        services.boatService.find({ query: { $sort: { order: 1 }}}).then(boats => {
          this.boats = boats.data
          this.fetching = false
          this.initDropdown()
        })
      },
      initDropdown() {
        setTimeout(() => {
          $('.ui.dropdown').dropdown()
        }, 50)
      },
      triggerMenu() {
        $('.ui.sidebar').sidebar('toggle')
      },
      openReservationDetails(reservation) {
        console.log('open reservation')
        this.editReservation = reservation
        $('#reservationModal').modal({
        }).modal('show')
      },
      showBoatModal() {
        $('#boatModal').modal('show')
      },
      editBoat(boat) {
        this.boat = boat
        this.showBoatModal()
      },
      addBoat(boat) {
        this.boat = {
          name: null,
          type: null,
          description: null,
          price: null,
          capacity: {
            min: null,
            max: null
          },
          startsAtHalfHour: false,
          order: 1,
          hidden: false,
          state: {
            battery: 100
          }
        }
        this.showBoatModal()
      },
      saveBoat() {
        if (this.boat._id) {
          services.boatService.patch(this.boat._id, this.boat).then(boat => {
            toastr.success('Boat saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        } else {
          services.boatService.create(this.boat).then(boat => {
            toastr.success('Boat saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        }
      },
      triggerDeleteBoat(boat) {
        this.boatForDelete = boat

        $('.ui.delete.modal').modal('show')
      },
      deleteBoat(boat) {
        services.boatService.remove(boat._id).then(boat => {
          toastr.info(`Removed boat <strong>${boat.name}</strong>`, 'Boat removed!')
        })
      }
    },
    components: {
      VueEditor
    }
  }
</script>

<style scoped>
  .ui.calendar input {
    border: none;
    font-size: 1.3rem;
  }
  .red.item {
    color: #771d14;
  }
  .calendar.item {
    padding: 4px 1px 0;
  }
  .text.input input {
    border: none;
  }
  .text.input.item {
    padding: 10px;
  }
  .huge.menu.placeholder {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// Boats.vue?37c0ae36